/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '#utils/UNSAFE_classNames';
import { segmentStyles } from './themes/SegmentStyles.css';

type Props = {
  /**
   * True if the segment should be hidden.
   */
  isHidden?: boolean;

  /**
   * True if the segment should be highlighted.
   */
  isHighlighted?: boolean;

  /**
   * True if the literal is part of a date placeholder, such as mm/dd/yyyy.
   * If the date is partially specified or complete, this is false.
   */
  isPlaceholder?: boolean;

  /**
   * The text to display for this segment.
   */
  text: string;
};

/**
 * LiteralSegment is used to represent a literal separator in a calendar date,
 * such as the '/' in 11/29/2023.
 */
export const LiteralSegment = ({ isHidden, isHighlighted, isPlaceholder, text }: Props) => {
  const spanClasses = classNames([
    segmentStyles.literalBase,
    isPlaceholder && segmentStyles.placeholder,
    isHighlighted && segmentStyles.highlighted,
    isHidden ? segmentStyles.hidden : segmentStyles.notHidden
  ]);

  return (
    <span aria-hidden="true" class={spanClasses}>
      {text}
    </span>
  );
};
